
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"viewBox":"0 0 10 10","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M3.852 9.967c.322 0 .568-.13.738-.387l5.197-8.05c.129-.194.182-.364.182-.528 0-.428-.31-.732-.75-.732-.3 0-.48.105-.668.398L3.828 8.15l-2.42-3.07c-.176-.228-.363-.322-.627-.322-.44 0-.756.31-.756.738 0 .188.065.37.223.557l2.871 3.545c.205.252.428.369.733.369z"}})])
          )
        }
      }
    